function period_Reducer(state = [], action) {
    switch (action.type) {
        case 'PERIOD/SET':            
            return action.period;
        case 'PERIOD/CLEAR':
            return null;
        default:
            return state;
    }
}

export default period_Reducer;
